import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthorizationGuard } from '@shared/authentication/authentication.guard';
import {
  DAILY_WORKING_HOURS_PAGE,
  CONSTRUCTION_SITE_TIME_PAGE,
} from '@shared/constants/routing-constants';

const routes: Routes = [
  {
    path: DAILY_WORKING_HOURS_PAGE,
    canActivate: [AuthorizationGuard],
    loadComponent: () =>
      import('./pages/daily-working-hours/kfm-daily-working-hours-page.component').then(
        (m) => m.KfmDailyWorkingHoursPageComponent,
      ),
  },
  {
    path: CONSTRUCTION_SITE_TIME_PAGE,
    canActivate: [AuthorizationGuard],
    loadComponent: () =>
      import('./pages/construction-site-time/kfm-construction-site-time-page.component').then(
        (m) => m.KfmConstructionSiteTimePageComponent,
      ),
  },
];

export const timetrackingRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(routes);
